module.exports = __webpack_public_path__ + "static/media/football-carousel-2-320x480.59bbf624.jpg";